import type { ProjectColor } from '@/types'

const COLOR_CLASSES: Record<ProjectColor, string> = {
  green:  'bg-emerald-100 text-emerald-800',
  yellow: 'bg-amber-100 text-amber-800',
  red:    'bg-rose-100 text-rose-800',
  grey:   'bg-gray-100 text-gray-600',
}

const DOT_CLASSES: Record<ProjectColor, string> = {
  green:  'bg-emerald-500',
  yellow: 'bg-amber-400',
  red:    'bg-rose-500',
  grey:   'bg-gray-400',
}

const COLOR_LABELS: Record<ProjectColor, string> = {
  green:  'В сроках',
  yellow: 'Скоро дедлайн',
  red:    'Просрочка',
  grey:   'Приостановлен',
}

export default function StatusBadge({ color }: { color: ProjectColor }) {
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${COLOR_CLASSES[color]}`}>
      <span aria-hidden className={`inline-block h-2 w-2 rounded-full ${DOT_CLASSES[color]}`} />
      {COLOR_LABELS[color]}
    </span>
  )
}
